<div
  class="d-flex flex-column"
  [ngClass]="{ 'page-container': showBody }">
  <div class="shadow d-flex flex-column sticky-top bg-body">
    <div class="d-flex justify-content-between align-items-center py-2 px-3 p-sm-4">
      <a
        class="pays-logo"
        href="{{ websiteBaseUrl }}">
        <img
          ngSrc="./assets/logo.svg"
          alt="Paystashio logo"
          height="40"
          width="201"
          priority />
      </a>
    </div>
    @if (step && showProgress && !hideProgress) {
      <progressbar [value]="progress"></progressbar>
    }
  </div>

  <div class="flex-grow-1 overflow-hidden">
    <ng-content></ng-content>
  </div>
</div>
